<template>
  <div>
    <h1 class="text-h3 text-sm-h2 text-md-h1 font-weight-bold">
      Be the best you. Make the best us.
    </h1>
    <p class="text-h5 text-sm-h4 text-white mt-6 mt-sm-10">
      Join Our Community of Like-Minded Engineers
    </p>
    <v-btn
      class="mt-6"
      color="secondary"
      to="/benefits"
      size="large"
      min-height="48"
      @click="scrollToTop"
    >
      Learn More
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'MentoringSlide',
  methods: {
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
    }
  }
};
</script>

<style scoped>
</style>